import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { RouterLink, Router } from '@angular/router';
import { Subscription, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MeService } from '../../../core/services/me.service';
import { ClientConfigurationApprovalsService } from '../../../core/services/client-configuration-approvals.service';
import { ClientConfigurationApproval } from '../../../core/models/client-configuration-approval.model';

@Component({
  selector: 'app-client-configuration-approval-alert',
  templateUrl: './client-configuration-approval-alert.component.html',
  imports: [RouterLink],
})
export class ClientConfigurationApprovalAlertComponent implements OnInit, OnDestroy {
  private meService = inject(MeService);
  private clientConfigurationApprovalsService: ClientConfigurationApprovalsService =
    inject(ClientConfigurationApprovalsService);

  private router = inject(Router);

  approval: ClientConfigurationApproval | null = null;
  private clientId: number | null = null;
  private approvedSubscription: Subscription;
  private selectedClientChangedSubscription: Subscription;

  ngOnInit() {
    this.loadClientIdAndApproval();
    this.selectedClientChangedSubscription = this.meService.selectedClientChanged
      .subscribe(() => this.loadClientIdAndApproval());
    this.approvedSubscription = this.clientConfigurationApprovalsService.approved$
      .subscribe(approval => { this.approval = approval; });
  }

  ngOnDestroy() {
    this.selectedClientChangedSubscription?.unsubscribe();
    this.approvedSubscription?.unsubscribe();
  }

  get approvalPending(): boolean {
    return this.approval !== null && !this.approval.approvedAt &&
      !this.router.url.includes('/referral-program-protocol');
  }

  private loadClientIdAndApproval() {
    this.meService.get().subscribe(user => {
      this.clientId = user.defaultAllowedClientId || user.availableClients[0]?.id;
      this.loadApproval();
    });
  }

  private loadApproval() {
    if (!this.clientId) { return; }
    this.clientConfigurationApprovalsService.getPending(this.clientId).pipe(
      catchError(() => of({ clientConfigurationApproval: null }))
    ).subscribe(result => {
      this.approval = result.clientConfigurationApproval;
    });
  }
}
